// extracted by mini-css-extract-plugin
export default {"error_container":"style_error_container__2xt9K","error_body":"style_error_body__-jVlh","error_title":"style_error_title__xjIpH","error_button":"style_error_button__hWvmU"};